import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=faee03be&scoped=true&lang=pug&"
import script from "./DocumentDetails.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=faee03be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faee03be",
  null
  
)

export default component.exports